import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const BodyItem = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  background-color: ${ColorSF2.white};
`;
export const ItemName = styled.div`
  width: 27%;
  border-top: 1px solid ${ColorSF2.mediumGray};
  border-left: 1px solid ${ColorSF2.mediumGray};
  border-right: 1px solid ${ColorSF2.mediumGray};
  ${props =>
    props.isLastElement
      ? `border-bottom: 1px solid ${ColorSF2.mediumGray};`
      : ''}
  background-color: ${ColorSF2.lightGray};
  padding: 10px;
  display: flex;
  align-items: center;
  @media (max-height: 530px) {
    padding: 6px;
  }
`;
export const ItemContent = styled.div`
  width: 73%;
  border-top: 1px solid ${ColorSF2.mediumGray};
  border-right: 1px solid ${ColorSF2.mediumGray};
  ${props =>
    props.isLastElement
      ? `border-bottom: 1px solid ${ColorSF2.mediumGray};`
      : ''}
  background-color: ${ColorSF2.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-height: 530px) {
    padding: 6px;
  }
`;
